import { ActionType, createReducer } from 'typesafe-actions';
import { formatStatements } from 'store/utils';
import { formatCurrency } from 'utils/intl';
import statementListActions, { resetList } from './actions';
import { FormattedStatement, StatementState, StatementTypes } from './types';
import { ITEMS_PER_PAGE } from 'pages/Balance/sections/TableResults/config';

export const INITIAL_STATE: StatementState = {
  lastUpdated: '',
  list: [],
  previousDayValue: 0,
  totalValue: 0,
  balanceLast: 0,
  error: 0,
  isLoading: false,
  isSuccess: false,
  isStatementListFilled: false,
  hasMore: false,
};

export type RootStatementListActions =
  | ActionType<typeof statementListActions>
  | ReturnType<typeof resetList>;

const statementReducer = createReducer<
  StatementState,
  RootStatementListActions
>(INITIAL_STATE, {
  [StatementTypes.FetchListRequest]: (state) => ({
    ...state,
    error: 0,
    isLoading: true,
    isSuccess: false,
  }),
  [StatementTypes.FetchListSuccess]: (state, action) => {
    const {
      Records: statements,
      PreviousDay,
      Update,
      LastUpdated,
    } = action.payload;

    const formattedStatements = formatStatements(
      statements
    ) as FormattedStatement[];

    return {
      isLoading: false,
      error: 0,
      isSuccess: true,
      isStatementListFilled: !!statements.length,
      list: Update
        ? [...state.list, ...formattedStatements]
        : formattedStatements,
      previousDayValue: formatCurrency(PreviousDay),
      totalValue: action.payload.Total,
      balanceLast: action.payload.BalanceLast,
      lastUpdated: LastUpdated,
      hasMore: formattedStatements.length >= ITEMS_PER_PAGE,
    };
  },
  [StatementTypes.FetchListFailure]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
    isSuccess: false,
    isStatementListFilled: false,
    list: [],
  }),
  [StatementTypes.ListReset]: (state) => {
    return {
      ...state,
      list: [],
    };
  },
});

export default statementReducer;
